import { Link } from 'next-translate-routes-multi-domain';
import { MdChevronRight } from 'react-icons/md';
import Seo from '../Seo';
import CoorpHero from '../structure/CoorpHero';
import Layout from './Layout';

export default function CoorpLayout({
  headingOne,
  headingTwo,
  headingThree,
  breadcrubPages,
  children,
}: {
  headingOne: string;
  headingTwo: string;
  headingThree: string;
  breadcrubPages: {
    name: string;
    href?: string;
  }[];
  children: React.ReactNode;
}) {
  return (
    <Layout>
      <Seo />
      <main className='bg-gray-light'>
        <BackgroundBanner />
        <div className='relative mx-auto w-[90%] max-w-7xl pt-10 lg:w-[80%]'>
          <CoorpHero
            headingOne={headingOne}
            headingTwo={headingTwo}
            headingThree={headingThree}
          />
          <BreadCrumbs pages={breadcrubPages} />
          <div className='bg-white px-8 py-8 lg:px-16'>{children}</div>
        </div>
      </main>
    </Layout>
  );
}

function BackgroundBanner() {
  return (
    <>
      <style jsx>{`
        .background-banner {
          background: url('/images/background.png');
          height: 300px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          position: absolute;
          width: 100%;
        }
      `}</style>
      <div className='background-banner' />
    </>
  );
}

function BreadCrumbs({ pages }: { pages: { name: string; link?: string }[] }) {
  return (
    <div className='flex items-center bg-white p-5 text-sm text-[#2e3d4f] '>
      <Link href='/'>GINDUMAC</Link>
      {pages.map((page, index) => (
        <div key={index} className='flex items-center'>
          <MdChevronRight className='mx-1' />
          {page.link ? (
            <Link href={page.link ? page.link : ''}>{page.name}</Link>
          ) : (
            <span>{page.name}</span>
          )}
        </div>
      ))}
    </div>
  );
}

export function Text({ text, isLeft }: { text: string; isLeft?: boolean }) {
  return (
    <div className='mt-10'>
      <p
        className={
          (isLeft ? 'text-left' : 'text-center') + ' text-lg text-muted-500'
        }
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

export function Title({
  title,
  isLeft,
  hasDivider = true,
}: {
  title: string;
  isLeft?: boolean;
  hasDivider?: boolean;
}) {
  return (
    <div
      className={
        (isLeft ? 'items-left' : 'items-center') +
        ' mb-8 flex w-full flex-col justify-center space-y-12'
      }
    >
      <h3 className='text-center font-primary font-normal uppercase text-muted-500'>
        {title}
      </h3>
      {hasDivider && <hr className=' w-24 border-[1px] border-muted-500' />}
    </div>
  );
}

export function SubTitle({ title }: { title: string }) {
  return (
    <div className='mb-12 flex w-full flex-col items-center justify-center space-y-12'>
      <h4 className='font-primary font-normal uppercase text-muted-500'>
        {title}
      </h4>
    </div>
  );
}

export function ListItem({ text }: { text: string }) {
  return <li className='mt-4 text-lg text-muted-500'>{text}</li>;
}
